const actions = {
  GET_CHATR_ACTIVATION_REPORT_REQUEST_LIST:
    "GET_CHATR_ACTIVATION_REPORT_REQUEST_LIST",
  GET_CHATR_ACTIVATION_REPORT_REQUEST_LIST_SUCCESSFUL:
    "GET_CHATR_ACTIVATION_REPORT_REQUEST_LIST_SUCCESSFUL",
  GET_CHATR_ACTIVATION_REPORT_REQUEST_LIST_FAILED:
    "GET_CHATR_ACTIVATION_REPORT_REQUEST_LIST_FAILED",

  getChatrActivationReportRequestList: (searchData) => ({
    type: actions.GET_CHATR_ACTIVATION_REPORT_REQUEST_LIST,
    payload: { searchData },
  }),
  getChatrActivationReportRequestListSuccessful: (data) => ({
    type: actions.GET_CHATR_ACTIVATION_REPORT_REQUEST_LIST_SUCCESSFUL,
    payload: { data },
  }),
  getChatrActivationReportRequestListFailed: (error) => ({
    type: actions.GET_CHATR_ACTIVATION_REPORT_REQUEST_LIST_FAILED,
    payload: { error },
  }),
};

export default actions;
